/* eslint-disable max-len */
import { number, string } from 'prop-types'
import styled from 'styled-components'
import { prop } from 'styled-tools'
import colorsOptions from '../../../components/stories/fundamentals/colors-styles/constants'

const NewAppVersionSvg = styled.svg`
  width: ${prop('size', 36)}px;
  height: ${prop('size', 36)}px;

  .a {
    fill: ${prop('color', colorsOptions.greys['grey-100'])};
  }
`

function NewAppVersionIcon ({ color, hoverColor, size, ...props }) {
  return (
    <NewAppVersionSvg
      xmlns="http://www.w3.org/2000/svg"
      size={size}
      color={color}
      hoverColor={hoverColor}
      {...props}
      viewBox="0 0 32 32"
    >
      <defs>
        <clipPath id="clip-path">
          <rect className="a" width="32" height="32" />
        </clipPath>
      </defs>
      <g id="Gruppe_13">
        <path
          className="a"
          d="M15.992,28.376A13.115,13.115,0,0,1,3.077,13.015,13.009,13.009,0,0,1,7.048,5.687L6.89,8.873a1.44,1.44,0,0,0,1.366,1.508h.073A1.439,1.439,0,0,0,9.766,9.016l.32-6.435a1.433,1.433,0,0,0-.371-1.04,1.45,1.45,0,0,0-.994-.472L2.285.749A1.453,1.453,0,0,0,.776,2.116,1.437,1.437,0,0,0,2.142,3.625L4.9,3.764a15.958,15.958,0,0,0-1.981,20.7,16.024,16.024,0,0,0,13.068,6.79h0a1.44,1.44,0,0,0,0-2.88"
          transform="translate(0 0.736)"
        />
        <path
          className="a"
          d="M8.837,0H8.69A1.439,1.439,0,0,0,8.7,2.878h.012a13.106,13.106,0,0,1,9.009,22.756l.022-3.251a1.437,1.437,0,0,0-1.429-1.447h-.01a1.438,1.438,0,0,0-1.439,1.429l-.046,6.445a1.44,1.44,0,0,0,1.429,1.447L22.7,30.3h.01a1.441,1.441,0,0,0,.01-2.882l-2.682-.018a15.965,15.965,0,0,0,1.89-20.619A16,16,0,0,0,8.837,0"
          transform="translate(7.155 0)"
        />
      </g>
    </NewAppVersionSvg>
  )
}

NewAppVersionIcon.propTypes = {
  color: string,
  hoverColor: string,
  size: number
}

export default NewAppVersionIcon
